import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

export const textSize = (theme: Theme) => ({
  small: css`
    ${theme.presentation.badge.small.mobile}
    ${breakpoint.up('sm')} {
      ${theme.presentation.badge.small.desktop}
    }
  `,
  medium: css`
    ${theme.presentation.badge.medium.mobile}
    ${breakpoint.up('sm')} {
      ${theme.presentation.badge.medium.desktop}
    }
  `,
})

export const uppercase = css`
  text-transform: uppercase;
`
